<script>
import { defineComponent as _defineComponent } from "vue";
import { unref as _unref, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "magic-player-poster" };
import { inject } from "vue";
import { usePlayerRuntime } from "../composables/private/usePlayerRuntime";
import { usePlayerVideoApi } from "../composables/private/usePlayerVideoApi";
import { MagicPlayerInstanceId } from "../symbols";
export default /* @__PURE__ */ _defineComponent({
  __name: "MagicPlayerPoster",
  setup(__props) {
    const instanceId = inject(MagicPlayerInstanceId, void 0);
    if (!instanceId) {
      throw new Error(
        "MagicPlayerPoster must be nested inside MagicPlayerProvider."
      );
    }
    const { loaded } = usePlayerRuntime({
      id: instanceId
    });
    const { touched } = usePlayerVideoApi({
      id: instanceId
    });
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock(
        "div",
        _hoisted_1,
        [
          _renderSlot(_ctx.$slots, "default")
        ],
        512
        /* NEED_PATCH */
      )), [
        [_vShow, !_unref(loaded) || !_unref(touched)]
      ]);
    };
  }
});
</script>

<style>
.magic-player-poster {
  position: absolute;
  inset: 0;
}
</style>
